import { css } from 'styled-components';
import {
  getSpacing, SpacingName, ThemedFunctor, BreakpointQueryName,
} from '@doveit/lego';

export const formBox: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    background-image: url('/static/assets/city-outline.svg');
    background-repeat: no-repeat;
    background-position: center 65%;
  }
`;

export const formWrapper: ThemedFunctor = ({
  theme,
}) => css`
  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding: ${theme.spaceUnits.desktop.MEDIUM};
    border: 3px solid ${theme.palettes.neutrals.light};
    border-radius: 6px;
    max-width: 30rem;
    margin: 0 auto;
    background-color: ${theme.palettes.neutrals.lightest};
  }
`;

export const formTitle: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
  font-weight: bold;
`;
